import React from "react";

export const UnfilledIcon = ({ cls }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g clipPath="url(#clip0_231_2502)">
        <path
          d="M25.3333 2.66667H24V1.33333C24 0.979711 23.8595 0.640573 23.6095 0.390524C23.3594 0.140476 23.0203 0 22.6667 0C22.313 0 21.9739 0.140476 21.7239 0.390524C21.4738 0.640573 21.3333 0.979711 21.3333 1.33333V2.66667H10.6667V1.33333C10.6667 0.979711 10.5262 0.640573 10.2761 0.390524C10.0261 0.140476 9.68696 0 9.33333 0C8.97971 0 8.64057 0.140476 8.39052 0.390524C8.14048 0.640573 8 0.979711 8 1.33333V2.66667H6.66667C4.89921 2.66878 3.20474 3.37184 1.95496 4.62163C0.705176 5.87141 0.00211714 7.56587 0 9.33333L0 25.3333C0.00211714 27.1008 0.705176 28.7953 1.95496 30.045C3.20474 31.2948 4.89921 31.9979 6.66667 32H25.3333C27.1008 31.9979 28.7953 31.2948 30.045 30.045C31.2948 28.7953 31.9979 27.1008 32 25.3333V9.33333C31.9979 7.56587 31.2948 5.87141 30.045 4.62163C28.7953 3.37184 27.1008 2.66878 25.3333 2.66667ZM2.66667 9.33333C2.66667 8.27247 3.08809 7.25505 3.83824 6.50491C4.58839 5.75476 5.6058 5.33333 6.66667 5.33333H25.3333C26.3942 5.33333 27.4116 5.75476 28.1618 6.50491C28.9119 7.25505 29.3333 8.27247 29.3333 9.33333V10.6667H2.66667V9.33333ZM25.3333 29.3333H6.66667C5.6058 29.3333 4.58839 28.9119 3.83824 28.1618C3.08809 27.4116 2.66667 26.3942 2.66667 25.3333V13.3333H29.3333V25.3333C29.3333 26.3942 28.9119 27.4116 28.1618 28.1618C27.4116 28.9119 26.3942 29.3333 25.3333 29.3333Z"
          fill="currentColor"
        />
        <path
          d="M16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22Z"
          fill="currentColor"
        />
        <path
          d="M9 22C10.1046 22 11 21.1046 11 20C11 18.8954 10.1046 18 9 18C7.89543 18 7 18.8954 7 20C7 21.1046 7.89543 22 9 22Z"
          fill="currentColor"
        />
        <path
          d="M23 22C24.1046 22 25 21.1046 25 20C25 18.8954 24.1046 18 23 18C21.8954 18 21 18.8954 21 20C21 21.1046 21.8954 22 23 22Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_231_2502">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
